export function calculateTotalThickness(layers) {
  return layers
    .reduce((acc, cur) => acc + cur.thickness, 0);
}

export function calculateTotalPressedThickness(layers) {
  return layers
    .reduce((acc, cur) => acc + cur.pressedThickness, 0);
}



// WEBPACK FOOTER //
// ./src/lib/simulations/thickness.js